import React from 'react'
import * as R from 'ramda'

export const useActiveCategory = () => {
  const [output, setOutput] = React.useState(null)

  const hasOutput = R.not(R.isNil(output))

  const handleOutputChange = React.useCallback(
    category => () => {
      setOutput(category)
    },
    [setOutput],
  )

  const handleReset = React.useCallback(() => {
    setOutput(null)
  }, [setOutput])

  return {
    output,
    handleOutputChange,
    handleReset,
    hasOutput,
  }
}
